<template>
  <div>
    <label class="select-multiple__label" >{{label}}</label>
    <v-combobox
      multiple
      v-model="inputVal"
      :items="items"
      :class="`select-multiple ${required ? '--required' : ''}`"
      small-chips
      :change="changeVal"
      deletable-chips
      :persistent-hint="true"
      append-icon="bexsicon-menu-down">
      <template slot="item" slot-scope="data">
        <v-layout>
          <v-checkbox
            :input-value="data.tile.props.value"
            primary hide-details :label="data.item.text"
            class="mx-2"
            :disabled="data.item.disabled"
          />
          <v-tooltip class="select-multiple__info-box" v-if="data.item.disabled" right max-width="240" :color="data.item.disabledWarningColor || disabledWarningColor">
            <span slot="activator">
              <v-icon class="bexsicon-info" :color="data.item.disabledWarningColor || disabledWarningColor"/>
            </span>
            <p v-if="data.item.disabledMessage">{{data.item.disabledMessage}}</p>
            <p v-else>{{disabledMessage}}</p>
          </v-tooltip>
        </v-layout>
      </template>
    </v-combobox>
  </div>
</template>

<script>
export default {
  props: {
    value: { required: true },
    required: String,
    items: {
      type: Array,
      required: true
    },
    label: String,
    index: Number,
    onCallback: Function,
    disabledMessage: String,
    disabledWarningColor: {
      type: String,
      default: '#DC2C00'
    }
  },
  data() {
    return {
      inputVal: this.value
    };
  },
  computed: {
    changeVal() {
      this.onCallback(this.index, this.inputVal);
    }
  }
};
</script>

<style lang="scss" >
.select-multiple__label::after {
  content: '*';
  color: red;
  font-size: 0.9em;
  padding: 0.25em;
}

.select-multiple {
  margin: 0;
  padding: 0px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  position: relative;

  &__box {
    display: flex;
  }

  &__info-box {
    pointer-events: auto !important;
  }
  .v-label {
    position: relative !important;
    top: -23px;
    font-size: 14px;
    transform: none;
  }
  .v-input__slot {
    &::before {
      content: none !important;
    }

    .v-select__selections {
      color: var(--field-font-color);
      padding: 0 12px;
    }

    & .v-select__slot {
      border: 1px solid #dcdcdc !important;
      min-height: 30px;
      border-radius: 5px;
      &:hover {
        border: 1px solid #dcdcdc !important;
      }
    }
  }
}
.v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
}

.v-chip--small {
  background-color: #0093f0 !important;
  color: #ffffff !important;
  padding: 20px 0px;
}

.v-chip .v-chip__content {
  white-space: break-spaces;
}

.v-chip__close {
  font-size: 0.5rem !important;
  width: 15px !important;
  margin: 0 0 0 1rem;

  i {
    display: inline;
    position: relative;
    font-size: 0 !important;
  }

  i::after {
    content: 'x' !important;
    display: block;
    font-size: 1.5rem;
    width: 30px;
    top: -13px;
    left: 0;
    height: 30px;
    position: absolute;
    color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/SelectMultiple.vue